import * as React from "react";
import { LoggedIn, Login } from "@grandvisionhq/auth";
import { Loader, Button } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import { useFeatureToggles } from "@grandvisionhq/state";
/* empty css               */
const StepLogin = ({
  isLoading,
  isLoggedIn,
  labels,
  loginProps,
  onBackClick,
  onContinueClick
}) => {
  const { isSocialLoginForCheckoutEnabled } = useFeatureToggles();
  return /* @__PURE__ */ React.createElement("div", { className: "step-login" }, /* @__PURE__ */ React.createElement("div", { className: "step-login__container" }, isLoading ? /* @__PURE__ */ React.createElement(Loader, null) : isLoggedIn ? /* @__PURE__ */ React.createElement(LoggedIn, { onContinueClick }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", className: "step-login__title" }, labels.continueTitle), labels.continueSubtitle && /* @__PURE__ */ React.createElement("p", { "data-t": "checkout-footnote", className: "step-login__subtitle" }, labels.continueSubtitle), /* @__PURE__ */ React.createElement(
    Button,
    {
      "data-t": "checkout-button-continue",
      caption: labels.continueButtonLabel,
      className: "step-login__button",
      onClick: onContinueClick,
      "aria-label": labels.continueButtonLabel
    }
  ), /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", className: "step-login__title" }, labels.loginTitle), labels.continueSubtitle && /* @__PURE__ */ React.createElement("p", { className: "step-login__subtitle step-login__subtitle--login" }, labels.loginSubtitle), /* @__PURE__ */ React.createElement(
    Login,
    {
      ...loginProps,
      socialLoginButtonLabel: "checkout.action.login.google",
      showSocialLogin: isSocialLoginForCheckoutEnabled,
      showTitle: false
    }
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      "aria-label": labels.backClickLabel,
      onClick: onBackClick,
      className: "step-login__back-link",
      "data-t": "checkout-back-link"
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "chevron-left" }),
    labels.backClickLabel
  ));
};
export {
  StepLogin
};
//# sourceMappingURL=StepLogin.js.map
